    import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import api from "../../../services/api";
import {IEventEntry} from "../../../interfaces/IEventEntry";
    import {IResultShot} from "../../../interfaces/IResultShot";
    import Async from "react-select/async";
    import Swal from "sweetalert2";
    import Select from "react-select";
    import './ckeckbox.css'

export default function Summary() {
  const { id, eventEntryId } = useParams()
  const [eventResults, setEventResults] = useState<IResultShot[]>([])
  const [eventCategories, setEventCategories] = useState<number>()
  const [arrayEventCategories, setArrayEventCategories] = useState<{label: string, value: number}[]>([])
  const [caliber, setCaliber] = useState<string[]>([])
  const [arrayCalibers, setArrayCalibers] = useState<{label: string, value: string}[]>([])
  const [eventEntry, setEventEntry] = useState<any>()
  const [modality, setModality] = useState<string>()
  const navigate = useNavigate()

  const INITIAL_DATA = {
    value: 0,
    label: 'Selecione o Sócio',
  }

  const [athlete, setAthlete] = useState(INITIAL_DATA)

  useEffect(() => {
    if (id) {
      api.get('/api/result_shots/' + id)
        .then(resposta => {
          // Converter shot_value para número
          const results = (resposta.data?.results || []).map((shot: any) => ({
            ...shot,
            shot_value: Number(shot.shot_value)
          }))
          setEventResults(results)

          // Carregar dados do resultado para edição
          const resultData = resposta.data

          if (resultData?.athlete) {
            setAthlete({
              label: `${resultData.athlete.member_number || ""} - ${resultData.athlete.full_name}`,
              value: resultData.athlete.id
            })

            api.post(`/api/weapons/my/${resultData.athlete.id}`, {'active':true})
              .then(response => {
                const seen: string[] = []
                setArrayCalibers(response.data.map((weapon: any) => ({
                  label: weapon?.caliber?.description,
                  value: weapon?.caliber?.description
                })).filter((w: any) => {
                  if (seen.includes(w.label)) return false
                  seen.push(w.label)
                  return true
                }))
              })
          }

            api.get('/api/event_entries/' + resultData.event_entry_id)
                .then(resposta => {
                    setEventEntry(resposta.data)
                    setModality(resposta.data.matchDate?.eventStage?.event?.eventType?.modality)

                    // Sempre carregar as categorias disponíveis
                    setArrayEventCategories(resposta.data?.matchDate?.eventStage?.event?.event_categories.map((category: any) => ({
                        label: category.category_name,
                        value: category.id
                    })))
                })

          if (resultData?.event_category_id) {
            setEventCategories(resultData.event_category_id)
          }

          if (resultData?.caliber) {
            setCaliber(resultData.caliber.split(', ').filter(Boolean))
          }
        })
    }

    if (eventEntryId) {
      api.get('/api/event_entries/' + eventEntryId)
        .then(resposta => {
          setEventEntry(resposta.data)
          setModality(resposta.data.matchDate?.eventStage?.event?.eventType?.modality)


          // Sempre carregar as categorias disponíveis
          setArrayEventCategories(resposta.data?.matchDate?.eventStage?.event?.event_categories.map((category:any) => ({
              label: category.category_name,
              value: category.id
          })))

          if (!id) {
            // template de resultados do banco
            const eventResultsTemplate = resposta.data?.matchDate?.eventStage?.event?.event_results_templates
            const isTrap = resposta.data.matchDate?.eventStage?.event?.eventType?.modality === 'trap_single'

            const defaultResults: IResultShot[] = eventResultsTemplate?.map((template: any) => ({
              result_id: 0,
              shot_index: template.shot_index,
              shot_label: template.shot_label,
              shot_multiplier: template.shot_multiplier,
              shot_value: isTrap ? 1 : 0
            })) || []
            
            setEventResults(defaultResults)
          }
        })
    }
  }, [id, eventEntryId])

  useEffect(() => {
    if (modality === 'trap_single' && window.innerWidth >= 1200) {
      document.body.classList.add('toggle-sidebar')
      return () => { document.body.classList.remove('toggle-sidebar') }
    }
  }, [modality])


  async function socios(value = '') {
    const response = await api.get(`/api/athletes/getToSelect/?search=${value}`)
    return response.data.map((athlete: any) => ({
      label: `${athlete.member_number || ""} - ${athlete.full_name}`,
      validities: athlete.cr_validity_date,
      value: athlete.id,
      athleteEventTypes: athlete.athleteEventTypes || []
    }))
  }

  async function setSocios(data: any) {
    try {
      setAthlete(data)
      if (!id) {
        const eventTypeId = eventEntry?.matchDate.eventStage.event.event_types_id
        const athleteCategory = data.athleteEventTypes?.find((aet: any) => aet.event_type_id === eventTypeId)

        if (athleteCategory) {
          setEventCategories(Number(athleteCategory.event_category_id))
        }

        if (data.value) {
          api.post(`/api/weapons/my/${data.value}`, {'active':true})
            .then(response => {
              const seen: string[] = []
              setArrayCalibers(response.data.map((weapon: any) => ({
                label: weapon?.caliber?.description,
                value: weapon?.caliber?.description
              })).filter((w: any) => {
                if (seen.includes(w.label)) return false
                seen.push(w.label)
                return true
              }))
            })
        }
      }
    } catch (err: any) {
      console.log('Erro ao selecionar atleta:', err)
    }
  }

  const handleSave = async () => {
    try {
      // Validações
      if (!id && (!athlete.value || athlete.value === 0)) {
        await Swal.fire({
          title: 'Atenção!',
          text: 'Por favor, selecione um atleta!',
          icon: 'warning',
        })
        return
      }
      
      if (!eventCategories) {
        await Swal.fire({
          title: 'Atenção!',
          text: 'Por favor, selecione uma categoria!',
          icon: 'warning',
        })
        return
      }
      
      if (id) {
        await api.post(`/api/result_shots/by-result`, {
          result_id: id,
          event_category_id: eventCategories,
          caliber: caliber.join(', '),
          shots: eventResults
        })
      } else {
        const shotTotals = eventResults.reduce((sum, shot) => sum + Number(shot.shot_value), 0)
        
        const eventResultData = {
          athlete_id: athlete.value,
          event_category_id:  Number(eventCategories),
          caliber: caliber.join(', '),
          shot_totals: shotTotals,
          event_entry_id: Number(eventEntryId),
          shots: eventResults
        }
        
        await api.post(`/api/event_results/with-shots`, eventResultData)
      }

      await Swal.fire({
        title: 'Sucesso!',
        text: 'Resultados salvos com sucesso!',
        icon: 'success',
      })
      
      navigate(-1)
    } catch (error) {
      console.error(error)
      await Swal.fire({
        title: 'Erro!',
        text: 'Erro ao salvar!',
        icon: 'error',
      })
    }
  }

  return (
      <>
          <div className='row'>
              <div className='col-md-12'>
                  <h3 className='mb-2'>
                      <b>Súmula</b>
                  </h3>
                  <h5 className='mb-2'>
                      <b>{eventEntry?.matchDate?.eventStage?.event.title} - {eventEntry?.matchDate?.eventStage?.title}</b>
                  </h5>
              </div>
          </div>

          <div className='row my-4'>
              <div className="col-lg-12">
                  <div className="card">
                      <div className="card-body">

                          <div className="row g-3 mt-2">
                              <div className="col-md-6">
                                  <label htmlFor="socio" className="form-label">Atleta <i className="text-danger"> *</i></label>
                                  {(id) ? (
                                      <input type="text" className={"form-control"} value={athlete.label} disabled={true} readOnly={true} />
                                  ) : (
                                      <Async
                                          name="search"
                                          autoFocus={false}
                                          isLoading={false}
                                          cacheOptions
                                          loadOptions={socios}
                                          isDisabled={!!id}
                                          noOptionsMessage={() => "Nenhum registro encontrado"}
                                          onChange={(data: any) => {
                                              setSocios(data).then()
                                          }}
                                          value={athlete}
                                          defaultOptions
                                          menuPortalTarget={document.body}
                                          styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                                      />
                                  )}
                              </div>

                              <div className={"col-md-3"}>
                                  <label htmlFor="event_category" className="form-label">Categoria <i
                                      className="text-danger"> *</i></label>
                                  <Select
                                      options={arrayEventCategories}
                                      value={arrayEventCategories.find(option => option.value == eventCategories)}
                                      name='event_category'
                                      id='event_category'
                                      placeholder='Selecione uma categoria'
                                      onChange={(data: any) => {
                                          setEventCategories(data.value)
                                      }}
                                  />
                              </div>

                              <div className={"col-md-3"}>
                                  <label htmlFor="caliber" className="form-label">Calibre</label>
                                  <Select
                                      isMulti={modality === 'steel_gauge'}
                                      options={arrayCalibers}
                                      value={modality === 'steel_gauge'
                                          ? arrayCalibers.filter(option => caliber.includes(option.value))
                                          : arrayCalibers.find(option => option.value === caliber[0]) || null
                                      }
                                      name='caliber'
                                      id='caliber'
                                      placeholder='Selecione o calibre'
                                      noOptionsMessage={() => 'Nenhuma arma cadastrada'}
                                      onChange={(data: any) => {
                                          modality === 'steel_gauge'
                                              ? setCaliber(data.map((d: any) => d.value))
                                              : setCaliber(data ? [data.value] : [])
                                      }}
                                      isDisabled={!athlete.value || athlete.value === 0}
                                  />
                              </div>
                          </div>
                      </div>
                  </div>
              </div>

              <div className='col-md-12 mt-3'>
                  <div className='card'>
                      <div className='card-body'>
                          <div className="card-header"><strong>{modality !== 'steel_gauge' ? modality == 'trap_single' ? 'Planilha' : 'Alvo' : ''}</strong></div>
                          {modality === 'trap_single' ? (
                              <table className='table table-striped trap-table mt-3'>
                                  <tbody>
                                  <tr>
                                      <th style={{ borderRight: '4px double #dee2e6' }}>Serie </th>
                                      {eventResults.map((shot: IResultShot, index: number) => (
                                          <th
                                              key={`label-${shot.shot_index}`}
                                              scope='col'
                                              style={(shot.shot_index % 5 === 0) ? { borderRight: '4px double #dee2e6' } : {}}
                                          >
                                              &nbsp;&nbsp;{shot.shot_label}
                                          </th>
                                      ))}
                                      <th scope='col' className="text-center">Total</th>
                                  </tr>
                                  <tr>
                                      <td style={{ borderRight: '4px double #dee2e6' }}>
                                        <div className='dropdown'>
                                          <button className='btn btn-sm dropdown-toggle' type='button' data-bs-toggle='dropdown' aria-expanded='false'>
                                            <b>1</b>
                                          </button>
                                          <div className='dropdown-menu'>
                                            <a className='dropdown-item' style={{cursor:'pointer'}} onClick={() => setEventResults(eventResults.map(s => ({...s, shot_value: 1})))}>Marcar tudo</a>
                                            <a className='dropdown-item' style={{cursor:'pointer'}} onClick={() => setEventResults(eventResults.map(s => ({...s, shot_value: 0})))}>Desmarcar tudo</a>
                                          </div>
                                        </div>
                                      </td>
                                      {eventResults.map((shot: IResultShot, index: number) => (
                                          <td
                                              key={`checkbox-${shot.shot_index}`}
                                              style={(shot.shot_index % 5 === 0) ? { borderRight: '4px double #dee2e6' } : {}}
                                          >
                                              <label className='conainer' title={shot.shot_label}>
                                                  <input
                                                      type='checkbox'
                                                      id={`${athlete.value}-${shot.shot_index}`}
                                                      checked={shot.shot_value === 1}
                                                      onChange={(e) => {
                                                          const updated = [...eventResults];
                                                          updated[index].shot_value = e.target.checked ? 1 : 0;
                                                          setEventResults(updated);
                                                      }}
                                                      aria-label='Checkbox for following text input'
                                                  />
                                                  <span className='checkmark'></span>
                                              </label>
                                          </td>
                                      ))}
                                      <td className="text-center"><strong>{eventResults.reduce((sum, s) => sum + s.shot_value, 0)}</strong></td>
                                  </tr>
                                  </tbody>
                              </table>
                          ) : modality === 'steel_gauge' ? (
                                  <>
                                      <div className="card mb-3">
                                          <div className="card-header"><strong>Placa</strong></div>
                                          <div className="card-body">
                                              <table className="table table-striped">
                                                  <thead>
                                                  <tr>
                                                      <th scope="col" align={"center"}></th>
                                                      <th scope="col">Disparo</th>
                                                      <th scope="col">Total</th>
                                                  </tr>
                                                  </thead>
                                                  <tbody>
                                                  {eventResults.slice(0, 4).map((shot: IResultShot, index: number) =>
                                                      <tr key={`${shot.shot_index}`}>
                                                          <td align={"center"}>{shot.shot_label}</td>
                                                          <td>
                                                              <label className='conainer' title={shot.shot_label}>
                                                                  <input
                                                                      type='checkbox'
                                                                      id={`${athlete.value}-${shot.shot_index}`}
                                                                      checked={shot.shot_value === 1}
                                                                      onChange={(e) => {
                                                                          const updated = [...eventResults]
                                                                          updated[index].shot_value = e.target.checked ? 1 : 0
                                                                          setEventResults(updated)
                                                                      }}
                                                                      aria-label='Checkbox for following text input'
                                                                  />
                                                                  <span className='checkmark checkmark-placa'></span>
                                                              </label>
                                                          </td>
                                                          <td><strong>{shot.shot_value * shot.shot_multiplier}</strong></td>
                                                      </tr>
                                                  )}
                                                  </tbody>
                                              </table>
                                          </div>
                                      </div>
                                      <div className="card mb-3">
                                          <div className="card-header"><strong>Alvo</strong></div>
                                          <div className="card-body">
                                              <table className="table table-striped">
                                                  <thead>
                                                  <tr>
                                                      <th scope="col" align={"center"}></th>
                                                      <th scope="col">Disparo</th>
                                                      <th scope="col">Total</th>
                                                  </tr>
                                                  </thead>
                                                  <tbody>
                                                  {eventResults.slice(4).map((shot: IResultShot, index: number) =>
                                                      <tr key={`${shot.shot_index}`}>
                                                          <td align={"center"}>{shot.shot_label}</td>
                                                          <td>
                                                              <div className="input-group" style={{ maxWidth: '200px' }}>
                                                                  <button
                                                                      className="btn btn-outline-danger"
                                                                      type="button"
                                                                      onClick={() => {
                                                                          const updated = [...eventResults]
                                                                          updated[4 + index].shot_value = Math.max(0, updated[4 + index].shot_value - 1)
                                                                          setEventResults(updated)
                                                                      }}
                                                                  >
                                                                      -
                                                                  </button>
                                                                  <input
                                                                      type="number"
                                                                      className="form-control text-center"
                                                                      value={shot.shot_value}
                                                                      onFocus={(e) => e.target.select()}
                                                                      onChange={(e) => {
                                                                          const updated = [...eventResults]
                                                                          updated[4 + index].shot_value = Number(e.target.value)
                                                                          setEventResults(updated)
                                                                      }}
                                                                  />
                                                                  <button
                                                                      className="btn btn-outline-success"
                                                                      type="button"
                                                                      onClick={() => {
                                                                          const updated = [...eventResults]
                                                                          updated[4 + index].shot_value = updated[4 + index].shot_value + 1
                                                                          setEventResults(updated)
                                                                      }}
                                                                  >
                                                                      +
                                                                  </button>
                                                              </div>
                                                          </td>
                                                          <td><strong>{shot.shot_value * shot.shot_multiplier}</strong></td>
                                                      </tr>
                                                  )}
                                                  </tbody>
                                              </table>
                                          </div>
                                      </div>
                                  </>
                              ) : (
                                  <table className="table table-striped">
                                      <thead>
                                      <tr>
                                          <th scope="col" align={"center"}></th>
                                          <th scope="col">Disparo</th>
                                          <th scope="col">Total</th>
                                      </tr>
                                      </thead>
                                      <tbody>
                                      {(eventResults != undefined && eventResults.length > 0) ? (
                                          <>
                                              {eventResults.map((shot: IResultShot, index: number) =>
                                                  <tr key={`${shot.shot_index}`}>
                                                      <td align={"center"}>{shot.shot_label}</td>
                                                      <td>
                                                          <div className="input-group" style={{ maxWidth: '200px' }}>
                                                              <button
                                                                  className="btn btn-outline-danger"
                                                                  type="button"
                                                                  onClick={() => {
                                                                      const updated = [...eventResults];
                                                                      updated[index].shot_value = Math.max(0, updated[index].shot_value - 1);
                                                                      setEventResults(updated);
                                                                  }}
                                                              >
                                                                  -
                                                              </button>
                                                              <input
                                                                  type="number"
                                                                  className="form-control text-center"
                                                                  value={shot.shot_value}
                                                                  onFocus={(e) => e.target.select()}
                                                                  onChange={(e) => {
                                                                      const updated = [...eventResults];
                                                                      updated[index].shot_value = Number(e.target.value);
                                                                      setEventResults(updated);
                                                                  }}
                                                              />
                                                              <button
                                                                  className="btn btn-outline-success"
                                                                  type="button"
                                                                  onClick={() => {
                                                                      const updated = [...eventResults];
                                                                      updated[index].shot_value = updated[index].shot_value + 1;
                                                                      setEventResults(updated);
                                                                  }}
                                                              >
                                                                  +
                                                              </button>
                                                          </div>
                                                      </td>
                                                      <td><strong>{shot.shot_value * shot.shot_multiplier}</strong></td>
                                                  </tr>
                                              )}
                                          </>
                                      ) : (
                                          <tr>
                                              <td colSpan={3} className='text-center'>
                                                  Nenhum resultado lançado
                                              </td>
                                          </tr>
                                      )}
                                      </tbody>
                                  </table>
                              )}

                          {modality !== 'trap_single' && (
                              <div className="mt-3 text-end">
                                  <strong>Total: {eventResults.reduce((sum, shot) => sum + (shot.shot_value * shot.shot_multiplier), 0)}</strong>
                              </div>
                          )}

                          <div className='mt-3'>
                              <button className="btn btn-success me-2" onClick={handleSave}>
                                  Salvar
                              </button>

                              <button className="btn btn-danger btn-floating " onClick={() => navigate(-1)}>Voltar<br/></button>
                          </div>

                      </div>
                  </div>
              </div>

          </div>
      </>
  )
}
